import instObj from '@/backend/axios-instances'

const resource = "/projects"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  search(parameters) {
    return instance.get(`${resource}/search`, { params: parameters });
  },
  sync(parameters){
    return instance.post(resource, null, { params: parameters });
  }
}
